export default __webpack_public_path__ + "./image/d8b873b007481edf80cf94b5974a297b.png";